import React, { ChangeEvent, FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SelectField } from 'is24-corecss'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import './EmploymentStep.scss'
import { useReportViewEvent } from '../../hooks'
import { reportTrackingEvent } from '../../tracking/thunks'
import { ReduxState } from '../../store/reducers'
import { Progress } from '../../@types/progress'
import { updateAffordability, updateDefaultEmployment, updateEmployment } from '../../store/lead/leadSlice'
import { EmploymentStepIcon } from '../../components/icons/StepIcons/EmploymentStepIcon'

export interface EmploymentStepProps {
  goToNextStep: () => unknown
  goToPreviousStep?: () => unknown
  progress: Progress
  displayBack: boolean
}

const headline = 'Wie ist dein Beschäftigungsverhältnis?'

const employmentOptions = [
  'Angestellter',
  'Arbeiter',
  'Beamter',
  'Freiberufler',
  'Rentner',
  'Selbstständiger',
  'Arbeitssuchender',
  'Privatier',
]

export const EmploymentStep: FC<EmploymentStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'employment' })

  const {
    config: { theme },
    lead: { employment, equity, income },
  } = useSelector((state: ReduxState) => state)
  const dispatch = useDispatch()

  const affordability = Math.round((100 * (income ? income : 0) + (equity ? equity : 0)) / 1000) * 1000

  useEffect(() => {
    dispatch(updateDefaultEmployment('Angestellter'))
    dispatch(updateAffordability(affordability))
  }, [])

  const handleSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    dispatch(updateEmployment(event.target.value))
  }

  const onNextClick = () => {
    dispatch(
      reportTrackingEvent({
        pageTitle: 'employment',
        label: 'employment_submit',
        inputValue: `${employment}`,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: `${employment}`,
        },
      })
    )
    props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<EmploymentStepIcon />}
      headline={headline}
      isNextEnabled={true}
      dataTestingButton='employment-next-button'
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      goToNextStep={onNextClick}
      backgroundColor={theme.background}
      textColor={theme.text}
      displayBack={props.displayBack}
    >
      <div className='employment-container' data-testid='employment-container'>
        <span className='input-label align-left'>Beschäftigungsverhältnis</span>
        <div className='grid-item'>
          <div className='input-text-container'>
            <span className='employment-input-affix font-lightgray'></span>
            <SelectField
              id={'employment'}
              label={''}
              onChange={handleSelect}
              defaultValue='Angestellter'
              className='employment-input'
              data-testid='employment-input'
            >
              {employmentOptions.map((employmentOption) => (
                <option key={employmentOption} value={employmentOption}>
                  {employmentOption}
                </option>
              ))}
            </SelectField>
          </div>
        </div>
      </div>
    </StepTemplate>
  )
}
export default EmploymentStep
